/* eslint-disable react/jsx-filename-extension */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { LoadingSpinner } from 'yankees-react-utils';
import App from './App';

import 'yankees-react-utils/dist/yankees-react-utils.css';
import './styles/custom.css';
import 'react-datepicker/dist/react-datepicker.css';

import './i18n';

const rootElement = document.getElementById('root');

fetch('/oktaConfig.json')
    .then((response) => response.json())
    .then((cfg) => {
        ReactDOM.render((
            <BrowserRouter>
                <Suspense fallback={<div><LoadingSpinner /></div>}>
                    <App OktaAuth={cfg.OktaAuth} />
                </Suspense>
            </BrowserRouter>), rootElement);
    });
